export const getUserInfo = () => {
    const userAgent = navigator.userAgent;

    // Get Browser Info
    let browserName = "Unknown";
    if (userAgent.includes("Chrome")) {
        browserName = "Google Chrome";
    } else if (userAgent.includes("Firefox")) {
        browserName = "Mozilla Firefox";
    } else if (userAgent.includes("Safari")) {
        browserName = "Safari";
    } else if (userAgent.includes("Edge")) {
        browserName = "Microsoft Edge";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
        browserName = "Internet Explorer";
    }

    // Get OS Info
    let osName = "Unknown";
    if (userAgent.includes("Win")) {
        osName = "Windows OS";
    } else if (userAgent.includes("Mac")) {
        osName = "Mac OS";
    } else if (userAgent.includes("X11")) {
        osName = "Unix OS";
    } else if (userAgent.includes("Linux")) {
        osName = "Linux OS";
    }

    return `${browserName}-${osName}`

};

export const formatPhoneNumber = (value: string) => {
  if (typeof value !== "string") return "";
  if (!value) return "";
  const phoneNum = value.replace(/\D/g, "");
  switch (phoneNum.length) {
    case 0:
      return "";
    case 1:
    case 2:
    case 3:
      return `${phoneNum ? `(${phoneNum}` : ''}`;
    case 4:
    case 5:
    case 6:
      return `(${phoneNum.slice(0, 3)})${phoneNum.slice(3)}`;
    case 7:
    case 8:
    case 9:
    case 10:
      return `(${phoneNum.slice(0, 3)})${phoneNum.slice(3, 6)}-${phoneNum.slice(6)}`;
    default:
      return `(${phoneNum.slice(0, 3)})${phoneNum.slice(3, 6)}-${phoneNum.slice(6, 10)}`;
  }
};

// Generate unique ID for connection tracking
export const generateId = (): string => {
  try {
    return crypto.randomUUID();
  } catch {
    return `browser_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
};

// Save TMI token to localStorage
export const saveTMIToken = (token: string): void => {
  if (token) {
    localStorage.setItem('appKey', token);
    localStorage.setItem('tmiToken', token);
    localStorage.setItem('tmi_token', token);
  }
};

// Get TMI token from localStorage
export const getTMIToken = (): string | null => {
  return localStorage.getItem('tmi_token');
};

// Remove TMI token from localStorage
export const removeTMIToken = (): void => {
  localStorage.removeItem('tmi_token');
  localStorage.removeItem('tmiToken');
  localStorage.removeItem('appKey');
};